import cn from 'classnames';
import { ReactElement, ReactNode } from 'react';

import type { Spacing } from '@/ui/types';

import s from './Label.module.css';

export type LabelProps = {
  children: ReactNode;
  htmlFor?: string;
  spacing?: Spacing;
};

const Label = ({ children, spacing, htmlFor }: LabelProps): ReactElement => {
  const spc = spacing ? `spacing-${spacing}` : null;

  return (
    <label className={cn(s.label, spc)} htmlFor={htmlFor}>
      {children}
    </label>
  );
};

export default Label;
